import { Identifier, useTranslate } from 'react-admin';
import { SecurityInventoryItem } from '@x-guard/xgac-types/xgac';

export const SelectAllButton = (props: {
  selectedIds: Identifier[];
  onSelectionChange: (selectedIds: Identifier[]) => void;
  selectableItems: SecurityInventoryItem[];
}) => {

  const translate = useTranslate();
  const allSelected = props.selectableItems.length > 0 && props.selectedIds.length === props.selectableItems.length;

  return (
    <>
      {allSelected ? (
        <button type="button" className="select-all-button deselect-all-button" onClick={() => {

          props.onSelectionChange([]);

        }}>
          <span>{translate('general.text.deselect_all')}</span>
        </button>
      ) : (
        <>
          <button type="button" className="select-all-button" onClick={() => {

            props.onSelectionChange(props.selectableItems.map((item) => item._id));

          }}>
            <span>{translate('general.text.select_all')}</span>
          </button>
        </>
      )}
    </>
  );

};
